export function formatDate(timestamp) {
	if (!timestamp) return 'Information saknas';
	let date;
	if (typeof timestamp === 'number' && timestamp > 10000000000) {
		date = new Date(timestamp);
	} else if (typeof timestamp === 'number') {
		date = new Date(timestamp * 1000);
	} else {
		date = new Date(timestamp);
	}
	if (isNaN(date.getTime())) return 'Ogiltigt datum';
	return date.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function validateOrganizationNumber(orgNum) {
	if (!orgNum) return { valid: true };

	const cleaned = orgNum.replace(/[^\d-]/g, '');
	if (cleaned.length < 10) {
		return { valid: false, error: 'Organisationsnumret är för kort. Det ska vara 10 siffror.' };
	}
	if (cleaned.length > 11) {
		return { valid: false, error: 'Organisationsnumret är för långt. Det ska vara 10 siffror.' };
	}

	const pattern = /^(\d{6})-?(\d{4})$/;
	const match = cleaned.match(pattern);
	if (!match) {
		return { valid: false, error: 'Ogiltigt format. Använd format XXXXXX-XXXX eller 10 siffror.' };
	}

	const [, group1, group2] = match;
	const digits = group1 + group2;
	if (digits.length !== 10) {
		return { valid: false, error: 'Organisationsnumret måste innehålla exakt 10 siffror.' };
	}

	let sum = 0;
	for (let i = 0; i < 10; i++) {
		let digit = parseInt(digits[i]);
		if (i % 2 === 0) {
			digit *= 2;
			if (digit > 9) digit -= 9;
		}
		sum += digit;
	}
	if (sum % 10 !== 0) {
		return { valid: false, error: 'Organisationsnumret är inte giltigt enligt kontrollsiffran.' };
	}
	return { valid: true };
}

export function formatOrganizationNumber(orgNum) {
	if (!orgNum) return '';
	const cleaned = orgNum.replace(/[^\d]/g, '');
	if (cleaned.length === 10) {
		return `${cleaned.slice(0, 6)}-${cleaned.slice(6)}`;
	}
	return orgNum;
}
